import { doc, onSnapshot, type Unsubscribe } from "firebase/firestore";
import { db } from "@/config/firebase";
import type { CatalogEntry } from "@/types";

export function subscribeCatalogEntry(
  projectId: string,
  onData: (entry: CatalogEntry | null) => void,
  onError: (error: Error) => void,
): Unsubscribe {
  return onSnapshot(
    doc(db, "catalog", projectId),
    (snap) => {
      onData(snap.exists() ? (snap.data() as CatalogEntry) : null);
    },
    onError,
  );
}
